import { useState } from "react";
import { useTranslation } from "react-i18next";
import PrimaryButton from "../../../components/common/PrimaryButton";
import styles from "./header.module.scss";
import classNames from "classnames";
import { AuthConfig } from "../../../setup/context/config/authConfig";
import ContractTypeModal from "../../../components/contract/contractTypeModal";

interface Props {
  /**
   * Renders the create-project action disabled and always visible. Used by the organization
   * gate: an unapproved organization can't own a project yet, but the action still belongs in
   * the topbar so the screen matches the rest of the app.
   */
  disabled?: boolean;
}

const Header: React.FC<Props> = ({ disabled = false }: Props) => {
  const { t } = useTranslation();
  const authorities = AuthConfig.getUserInfo()?.authorities;
  const [typeModalOpen, setTypeModalOpen] = useState(false);

  return (
    <div
      className={classNames(
        styles.header,
        styles.flexRow,
        styles.alignCenter,
        styles.justifyEnd,
        styles.py24,
        styles.gap16,
        styles.borderBottomLight
      )}>
      <h3 className={styles.title}>{t("lbl_business_home")}</h3>

      <div className={styles.createButton}>
        {(disabled ||
          authorities?.includes("CLIENT_ADMIN_CREATE_CONTRACT") ||
          authorities?.includes("CLIENT_ADMIN") ||
          authorities?.includes("ORGANIZATION_OWNER")) && (
          <PrimaryButton
            disabled={disabled}
            onClick={() => {
              if (disabled) return;
              setTypeModalOpen(true);
            }}>
            {t("lbl_create_new_project")}
          </PrimaryButton>
        )}
      </div>
      <ContractTypeModal
        visible={typeModalOpen}
        onClose={() => setTypeModalOpen(false)}
      />
    </div>
  );
};

export default Header;
